import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import StyledMenu from "./StyledMenu";
import Popover from "@material-ui/core/Popover";
import Select from "react-select";
import { OptionFormatter, colourStyles } from "../common/ColumnSelector";

export default function GroupSubMenu(props) {
  const [column, setColumn] = React.useState("");

  let options = props.columns.filter(
    (column) => column.value && !props.groupedColumns.includes(column.value)
  );

  const itemSelected = (object) => {
    props.itemSelected(object);
  };

  const closeMenu = () => {
    props.closeMenu();
  };

  return (
    <Popover
      id={Boolean(props.anchorEl) ? "simple-popover" : undefined}
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={closeMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Select
        onChange={(selectedOption) => {
          itemSelected(selectedOption);
        }}
        components={{
          DropdownIndicator: null,
          indicatorSeparator: null,
        }}
        options={options}
        menuIsOpen={true}
        formatOptionLabel={(data) => {
          return OptionFormatter(data.label ? data.label : data.value);
        }}
        styles={props.hideSearchBar ? valueContainerStyles : colourStyles}
        isClearable={false}
        autoFocus={true}
        isSearchable={props.hideSearchBar ? false : true}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
      />
    </Popover>
  );
}

const valueContainerStyles = {
  ...colourStyles,
  valueContainer: () => ({
    height: 0,
  }),
};
